import Footer from './Footer.vue';
import Header from './Header.vue';
import PZLink from './PZLink.vue';

const Components = [Footer, Header, PZLink];
const install = (Vue) => {
  Components.forEach((component) => {
    Vue.component(component.name, component);
  });
};
export default {
  install,
};
